import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { cartesianAxis, PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE =
  "Month,Revenue,Users\nJan,120,40\nFeb,145,58\nMar,138,72\nApr,180,95\nMay,205,120";

export function LinePlot({ area = false }: { area?: boolean }) {
  return (
    <PlotShell
      toolId={area ? "area-chart" : "line-chart"}
      inputLabel={m.plot_input_label()}
      placeholder={m.line_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => {
        const multi = data.colHeaders.length > 1;
        return {
          tooltip: { trigger: "axis" },
          legend: multi
            ? {
                data: data.colHeaders,
                bottom: 0,
                textStyle: { color: theme.muted },
              }
            : undefined,
          grid: { left: 48, right: 20, top: 20, bottom: multi ? 44 : 30 },
          xAxis: {
            type: "category",
            data: data.rowLabels,
            boundaryGap: false,
            ...cartesianAxis(theme),
          },
          yAxis: { type: "value", ...cartesianAxis(theme) },
          series: data.colHeaders.map((name, ci) => {
            const color = SCI_PALETTE[ci % SCI_PALETTE.length];
            return {
              name,
              type: "line",
              smooth: true,
              showSymbol: true,
              symbolSize: 5,
              data: data.matrix.map((row) =>
                Number.isFinite(row[ci]) ? row[ci] : null,
              ),
              lineStyle: { width: 2, color },
              itemStyle: { color },
              areaStyle: area ? { color, opacity: 0.18 } : undefined,
            };
          }),
        };
      }}
    />
  );
}
